/**
 * Serviço para cuidar do processamento dos sinais provenientes originários da visão computacional
 * e execução de ações ligadas a eles. As ações que não
 *
 */

import { Injectable } from '@angular/core';
import { MathHelperService } from 'src/app/nav-driver/vision-web/math-helper.service';
import { VisionService } from 'src/app/nav-driver/vision-web/vision.service';
import { BehaviorSubject } from 'rxjs';
import { __exportStar } from 'tslib';
import {
  ActionFilterClass,
  ActionOption,
  MappingsItemSettings,
  MappingsServiceSettings,
  MappingsServiceState,
  MovementFilterClass,
  MovementOption,
  MovementSource,
  MappingsOutputType,
  MappingsOutput,
} from './mappings.model';
import { Profile } from 'src/app/profile/profile.model';
import { ProfileService } from 'src/app/profile/profile.service';
import { selectorValues } from 'src/app/manual-settings/manual-settings.data';
import { FaceLandmarkerResult } from '@mediapipe/tasks-vision';
import { PeyeCoordinates, PeyeService } from 'src/app/nav-driver/peye/peye.service';
import { SoundService } from 'src/app/sound/sound.service';
import { AndroidControlService } from 'src/app/androidControl/androidControl.service';
import { PermissionService } from 'src/app/permissions/permission.service';
import { EyeTrackerService } from 'src/app/nav-driver/tobii/eye-tracker.service';
import { MouseDriverData, NavCursorData } from 'src/app/nav-overlay/navigation-cursor.model';
import { RastreadorCoords, RastreadorOcularService } from 'src/app/nav-driver/rastreador/rastreador.service';
import { MouseService } from 'src/app/nav-driver/mouse/mouse.service';

@Injectable({
  providedIn: 'root',
})
export class MappingsService {
  settings: MappingsServiceSettings = {} as MappingsServiceSettings;

  state: MappingsServiceState = {} as MappingsServiceState;

  continuousMovements = 0; // Contagem da quantidade de controles de cursor correspondente ao tipo de persona 0, 1 ou 2

  globalCommandsBS = new BehaviorSubject<'enableControl' | 'disableControl'>(
    'enableControl'
  );

  /**
   * Emits events corresponding to the output of the mappings system
   */
  outputBS = new BehaviorSubject<MappingsOutput>({
    type: MappingsOutputType.none,
  });

  // Updated count of how many inputs are cursor controls
  // TODO: Impedir que mais de um movimento seja vinculado ao mesmo cursor na edição manual
  numberOfCursorControls: number;

  calibrationValue: number;

  //audio = new Audio();

  currentResH: number;
  currentResV: number;
  currentResHV: number;


  private lastMovementTimestamp: number;


  constructor(
    //private mathHelper: MathHelperService,
    public vision: VisionService,
    private peyeTracker: PeyeService,
    private eyeTracker: EyeTrackerService,
    private mathHelper: MathHelperService,
    private rastreador: RastreadorOcularService,
    private mouse: MouseService,
    private profile: ProfileService,
    public sound: SoundService,
    public androidControl: AndroidControlService,
  ) {

    vision.captureResultCallback = (data) => this.faceDataHandler(data);
    peyeTracker.captureResultCallback = (data) => this.peyeTrackerDataHandler(data);
    eyeTracker.captureResultCallback = (data) => this.eyeTrackerDataHandler(data);
    rastreador.captureResultCallback = (data) => this.rastreadorDataHandler(data);
    mouse.captureResultCallback = (data) => this.mouseDataHandler(data);


    if (!this.profile.profile.navSettingsBundle) {
      this.settings = profile.mappingsSettings as MappingsServiceSettings;
    }

    this.state = {
      muted: false,
      mappings: [],
      dispatchMouse: true,
    };

    this.profile.mappingsSettings$.subscribe((v) => { // TODO: legado, remover

      if (this.profile.profile.navSettingsBundle) {
        return;
      }
      if (!v?.mappings) {
        return;
      }

      console.log('new setting', v);

      // We need to keep the settings and state arrays the same length
      if (v && (v.mappings.length !== this.state.mappings.length)) {
        this.disable();
        this.state.mappings = [];

        v.mappings.forEach((element) => {
          this.state.mappings.push({
            detected: false,
            suspected: false,
            detectionLevel: 0,
            rescaledValue: 0,
            discretizedValue: 0,
            lastHysteresisRef: 0,
            lastDelta: 0,
            output: 0,
            dispatchPending: false,
            startTimestamp: 0,
          });
        });
        //console.log('new state', this.state.mappings);
      }
      this.settings = v as MappingsServiceSettings;
      this.enable();
    });

    // this.profile.profile$.subscribe((profile) => {
    //   //console.log('mappings profile', profile);
    //   if (profile.navSettingsBundle) {
    //     this.setProfile(profile);
    //   }
    // });


  }

  faceDataCallback = (data: any) => this.faceDataHandler(data);
  handDataCallback = (data: any) => this.handDataHandler(data);


  // Process data from hands
  handDataHandler(data: any) {
    // console.log(data);
    // if (this.settings.enabled) {
    //   // Split data by handedness
    //   data.handednesses.forEach((handedness: any, index: number) => {
    //     if (handedness[0].index === 0) {
    //       // model Left = inverted right
    //       this.actionMapper(
    //         {
    //           gestures: data.gestures[index],
    //           landmarks: data.landmarks[index],
    //         },
    //         MovementSource.lefHand
    //       );
    //     } else {
    //       this.actionMapper(
    //         {
    //           gestures: data.gestures[index],
    //           landmarks: data.landmarks[index],
    //         },
    //         MovementSource.rightHand
    //       );
    //     }
    //   });
    // } else {
    //   this.disable();
    // }
  }

  // Process data from face
  faceDataHandler(data: any) {
    if (this.settings?.enabled) {
      this.actionMapper(data, MovementSource.face);
    } else {
      this.disable();
    }
  }

  rastreadorDataHandler(data: { captureTime: number; coordinates: RastreadorCoords }) {
    //console.log('rastreadorDataHandler', data);
    if (this.settings?.enabled) {
      this.actionMapper({ captureTime: data.captureTime, result: data.coordinates }, MovementSource.eyeTracker);
    } else {
      this.disable();
    }
  }

  peyeTrackerDataHandler(data: { captureTime: number; coordinates: PeyeCoordinates }) {
    //console.log('eyeTrackerDataHandler', data);
    if (this.settings?.enabled) {
      this.actionMapper({ captureTime: data.captureTime, result: data.coordinates }, MovementSource.eyeTracker);
    } else {
      this.disable();
    }
  }

  eyeTrackerDataHandler(data: { captureTime: number; coordinates: PeyeCoordinates }) {
    //console.log('eyeTrackerDataHandler', data);
    if (this.settings?.enabled) {
      this.actionMapper({ captureTime: data.captureTime, result: data.coordinates }, MovementSource.eyeTracker);
    } else {
      this.disable();
    }
  }

  navCursorDataHandler(data: { captureTime: number; navData: NavCursorData }) {
    //console.log('navCursorDataHandler', data);
    if (this.settings?.enabled) {
      this.actionMapper({ captureTime: data.captureTime, result: data.navData }, MovementSource.navigationCursor);
    } else {
      this.disable();
    }
  }

  mouseDataHandler(data: { captureTime: number; mouseData: MouseDriverData }) {
    //console.log('mouseDataHandler', data);
    if (this.settings?.enabled) {
      this.actionMapper({ captureTime: data.captureTime, result: data.mouseData }, MovementSource.mouse);
    } else {
      this.disable();
    }
  }

  // Custom comparison for hands sources to deal with both hands as source
  compareHandsSource(source: MovementSource, filter: MovementSource) {
    if (source === filter) {
      return true;
    } else if (
      filter === MovementSource.hands &&
      (source === MovementSource.lefHand || source === MovementSource.rightHand)
    ) {
      return true;
    }
    return false;
  }

  // TODO LEGACY: will be replaced by new settings bundle structure
  // updateMappingsReport() {
  //   // Evaluate type of persona
  //   //console.log('updateMappingsReport', this.settings);
  //   let counter = 0;
  //   this.settings?.mappings?.forEach(
  //     (mapping: MappingsItemSettings, index: number) => {
  //       if (
  //         mapping.detectionAction?.filterClass ===
  //         ActionFilterClass.cursorPosition
  //       ) {
  //         counter++;
  //       }
  //     }
  //   );

  //   this.numberOfCursorControls = counter % 3;
  // }

  ///////////////////////////////////////
  // Core of the mapping system
  ///////////////////////////////////////
  // Search for all defined gestures in the incoming data and calls corresponding action function
  // Deals with activation criteria and event emission
  actionMapper(
    data: { captureTime: number; result: FaceLandmarkerResult | PeyeCoordinates | RastreadorCoords | NavCursorData | MouseDriverData },
    source: MovementSource
  ) {
    //console.log(this.settings.mappings.length);
    //console.log("mappings data", data.result);
    this.settings?.mappings.forEach(
      (mapping: MappingsItemSettings, index: number) => {
        // Tratamento do reset do dwell timer por mudança do cursor de navegação
        if (source === MovementSource.navigationCursor) {
          //console.log('reset dwell', data);
          if (mapping.enabled && data?.result['event'] === 'cursorPositionChanged') {
            this.lastMovementTimestamp = Date.now();
          }
        }
        else if (
          mapping.enabled &&
          this.compareHandsSource(source, mapping.movement.source)
          && (this.state.muted ? mapping.detectionAction?.filterClass === ActionFilterClass.control : true)
          && data
        ) {
          this.state.mappings[index].detectionLevel = this.functionFromId(
            mapping.movement.function
          )?.call(this, data?.result);

          // Continuous
          if (mapping.resolution == 0 || mapping.resolution > 1) {
            // TODO: processamento do sinal: escala, histerese e discretização feito na ação. trazer para cá!

            this.state.mappings[index].rescaledValue = this.normalizeRange(
              mapping.range?.lower || mapping.rescaleMin || 0,
              this.hysteresis(index),
              mapping.range?.upper || mapping.rescaleMax || 1
            );

            // this.state.mappings[index].discretizedValue =
            //   this.discretizeInteger(
            //     this.state.mappings[index].rescaledValue,
            //     mapping.resolution || 6
            //   );

            // if(this.state.mappings[index].output !== discretizedValue) {
            //   this.state.mappings[index].output = discretizedValue;

            this.functionFromId(mapping.detectionAction?.function)?.call(
              this,
              index,
              data.captureTime
            );
            // }
          }
          // Discrete
          else {
            let newDetection: boolean;

            // Threshold detection
            // Hysteresis: decrease threshold by mapping.hysteresis percentage
            if (mapping.hysteresis && this.state.mappings[index]?.detected) {
              // Seek detection end
              newDetection =
                this.state.mappings[index].detectionLevel >
                mapping.detectionThreshold * (1 - mapping.hysteresis);
            } else {
              // Seek detection start
              newDetection =
                this.state.mappings[index].detectionLevel >
                mapping.detectionThreshold;
            }

            // Send control action only if something changes
            if (this.state.mappings[index].suspected !== newDetection) {
              if (newDetection) {
                // Execute new suspicion function
                this.state.mappings[index].suspected = true;
                this.state.mappings[index].startTimestamp = Date.now();
                // Execute defined action
                if (mapping.preDetectionAction) {
                  this.functionFromId(
                    mapping.preDetectionAction.function
                  )?.call(this, index, true, true, true, data.captureTime);
                }
              } else {
                // Exutute suspecion cancel function
                this.state.mappings[index].suspected = false;
                // Execute defined action
                if (mapping.preDetectionCancelAction) {
                  this.functionFromId(
                    mapping.preDetectionCancelAction.function
                  )?.call(this, index, true, true, true, data.captureTime);
                }
              }
            }

            // Check hold time
            if (mapping.holdTime > 0 && newDetection) {
              if (
                Date.now() - this.state.mappings[index].startTimestamp <
                mapping.holdTime
              ) {
                // End here if hold
                return;
              }
            }

            // Send control action only if something changes
            if (this.state.mappings[index].detected !== newDetection) {
              this.state.mappings[index].dispatchPending = true;
              if (newDetection && mapping.actionSound?.function) {
                // Play sound
                const src = `assets/sounds/${mapping.actionSound?.function}.mp3`;
                this.sound.requestSound(src, 0, mapping.actionSoundVolume).then((res) => { }, (error) => { });
                //this.playAudio(mapping.actionSound?.function);
              }
            }
            this.state.mappings[index].detected = newDetection;
            // Execute defined action
            if (
              mapping.detectionAction &&
              (mapping.detectionAction.filterClass !==
                ActionFilterClass.cursorPosition)
            ) {
              this.state.mappings[index].dispatchPending = this.functionFromId(
                mapping.detectionAction.function
              )?.call(
                this,
                index,
                this.state.mappings[index].detected,
                mapping?.actionArg,
                this.state.mappings[index].dispatchPending,
                data.captureTime
              );
            }
            //console.log(this.state.mappings[index].dispatchPending, index);
          }
        }
      }
    );
  }

  enable() {
    if (this.settings?.enabled) {
      //this.vision.state.faceDataCallbacks.push(this.faceDataCallback);
    }
  }

  disable() {
    // this.vision.state.faceDataCallbacks.splice(
    //   this.vision.state.faceDataCallbacks.indexOf(this.faceDataCallback)
    // );
  }

  setresH(res: number) {
    this.currentResH = res;
    //console.log('setresH', res);
  }

  setResV(res: number) {
    this.currentResV = res;
    //console.log('setresV', res);
  }

  setResHV(res: number) {
    this.currentResHV = res;
  }

  createMapping(): number {
    const index = this.settings.mappings.length;
    this.settings.mappings.push({
      name: 'Binding ' + (index + 1).toString(),
      enabled: true,
      priority: 0,
      resolution: 6,
      movement: {
        name: 'movimento',
        function: null,
        source: null,
        filterClass: MovementFilterClass.none,
      },
      detectionThreshold: 0.5,
      detectionAction: {
        name: 'resultado',
        function: null,
        filterClass: ActionFilterClass.none,
      },
      rescaleMax: 1,
      rescaleMin: 0,
      hysteresis: selectorValues.hysteresis[1].value,
    });

    this.state.mappings.push({
      detected: false,
      suspected: false,
      detectionLevel: 0,
      rescaledValue: 0,
      discretizedValue: 0,
      lastHysteresisRef: 0,
      lastDelta: 0,
      output: 0,
      dispatchPending: false,
      startTimestamp: 0,
    });

    this.profile.mappingsSettings = this.settings;

    return index;
  }

  removeMapping(index) {
    return this.settings.mappings.splice(index, 1);
  }

  filterMouseMappings(mappingSettings: MappingsItemSettings[]) {
    return mappingSettings.filter(
      (m) => m.detectionAction.filterClass === ActionFilterClass.mouse
    );
  }

  filterKeyboardMappings(mappingSettings: MappingsItemSettings[]) {
    return mappingSettings.filter(
      (m) => m.detectionAction.filterClass === ActionFilterClass.keyboard
    );
  }

  filterAutomationMappings(mappingSettings: MappingsItemSettings[]) {
    return mappingSettings.filter(
      (m) => m.detectionAction.filterClass === ActionFilterClass.automation
    );
  }

  ngForMappingTrackByFn(index: number, el: any) {
    return el.id;
  }

  functionOptionCompareWith(
    o1: MovementOption | ActionOption,
    o2: MovementOption | ActionOption
  ) {
    return o1 && o2 ? o1.function === o2.function : o1 === o2;
  }

  normalizeRange(min: number, point: number, max: number) {
    if (point < min) {
      point = min;
    } else if (point > max) {
      point = max;
    }
    return (point - min) / (max - min);
  }

  // discretiza com saída normalizada entre 0 e 1
  discretizeNormalized(value: number, resolution: number): number {
    return Math.floor(value * resolution) / resolution;
  }

  // Discretiza com saida inteira
  discretizeInteger(value: number, resolution: number): number {
    const output = value * resolution;
    return Math.min(Math.max(Math.floor(output), 0), resolution - 1);
  }

  // Histeresis for digital output
  hysteresis(index: number) {
    const itemState = this.state.mappings[index];
    const hysteresis =
      (this.settings.mappings[index].hysteresis *
        ((this.settings.mappings[index].rescaleMax || 1) -
          (this.settings.mappings[index].rescaleMin || 0))) /
      this.settings.mappings[index].resolution;
    if (hysteresis) {
      if (
        (itemState.lastDelta >= 0 &&
          itemState.detectionLevel <= itemState.lastHysteresisRef &&
          itemState.detectionLevel + hysteresis >
          itemState.lastHysteresisRef) ||
        (itemState.lastDelta <= 0 &&
          itemState.detectionLevel >= itemState.lastHysteresisRef &&
          itemState.detectionLevel - hysteresis < itemState.lastHysteresisRef)
      ) {
        return itemState.lastHysteresisRef;
      } else {
        itemState.lastDelta =
          itemState.detectionLevel - itemState.lastHysteresisRef;
        itemState.lastHysteresisRef = itemState.detectionLevel;
        return itemState.detectionLevel;
      }
    } else {
      // Não precisa aplicar histerese
      return itemState.detectionLevel;
    }
  }

  numericalOptionCompareWith(n1: number, n2: number) {
    return n1 !== undefined ? n1 === n2 : n2 === 0;
  }

  mappingsValidator(index: number) {
    // Se o editado for um cursor HV e estiver ligado:
    // Desliga cursores unidirecionais
    // Se o editado for um cursor H ou V e estiver ligado:
    // Desliga cursor HV
  }

  saveOnProfile() {
    this.profile.mappingsSettings = this.settings;
    //this.profile.commit();
  }
  /////////////////////////////////////////
  // Gesture Finders - Face
  /////////////////////////////////////////
  // https://arkit-face-blendshapes.com/
  // findJawOpen(data: any) {
  //   return data.faceBlendshapes[0]?.categories[25].score;
  // }
  findMouthPuck(data: any) {
    // mouthPucker - mouthRight - mouthLeft
    return (
      data.faceBlendshapes[0]?.categories[38].score -
      data.faceBlendshapes[0]?.categories[39].score -
      data.faceBlendshapes[0]?.categories[33].score
    );
  }
  findMouthPuckLeft(data: any) {
    return data.faceBlendshapes[0]?.categories[33].score;
  }
  findMouthPuckRight(data: any) {
    return data.faceBlendshapes[0]?.categories[39].score;
  }
  findLeftEyeBlink(data: any) {
    return data.faceBlendshapes[0]?.categories[9].score;
  }
  findRightEyeBlink(data: any) {
    return data.faceBlendshapes[0]?.categories[10].score;
  }
  findLeftOnlyEyeBlink(data: any) {
    // left - right
    return Math.max(
      data.faceBlendshapes[0]?.categories[9].score -
      data.faceBlendshapes[0]?.categories[10].score,
      0
    );
  }
  findRightOnlyEyeBlink(data: any) {
    // right - left
    return Math.max(
      data.faceBlendshapes[0]?.categories[10].score -
      data.faceBlendshapes[0]?.categories[9].score,
      0
    );
  }
  findLeftAndRightEyeBlink(data: any) {
    // min(right, left)
    return Math.min(
      data.faceBlendshapes[0]?.categories[10].score,
      data.faceBlendshapes[0]?.categories[9].score
    );
  }
  findLeftOrRightEyeBlink(data: any) {
    // max(right, left)
    return Math.max(
      data.faceBlendshapes[0]?.categories[10].score,
      data.faceBlendshapes[0]?.categories[9].score
    );
  }
  findEyeBrowUp(data: any) {
    return Math.max(
      data.faceBlendshapes[0]?.categories[3].score, // browInnerUp
      data.faceBlendshapes[0]?.categories[4].score, // browOuterUpLeft
      data.faceBlendshapes[0]?.categories[5].score, // browOuterUpRight
    );
  }
  findEyeBrowDown(data: any) {
    return Math.max(
      data.faceBlendshapes[0]?.categories[1].score, // browDownLeft
      data.faceBlendshapes[0]?.categories[2].score  // browDownRight
    );
  }
  findGazeUp(data: any) {
    //( eyeGazeUpLeft + eyeGazeUpRight) / 2
    return (
      (data.faceBlendshapes[0]?.categories[17].score +
        data.faceBlendshapes[0]?.categories[18].score) /
      2
    );
  }
  findGazeDown(data: any) {
    //( eyeGazeDownLeft + eyeGazeDownRight) / 2
    return (
      (data.faceBlendshapes[0]?.categories[11].score +
        data.faceBlendshapes[0]?.categories[12].score) /
      2
    );
  }
  findGazeLeft(data: any) {
    // (eyeGazeInRight + eyeGazeOutLeft) / 2
    return (
      (data.faceBlendshapes[0]?.categories[14].score +
        data.faceBlendshapes[0]?.categories[15].score) /
      2
    );
  }
  findGazeRight(data: any) {
    // (eyeGazeInLeft + eyeGazeOutRight) / 2
    return (
      (data.faceBlendshapes[0]?.categories[13].score +
        data.faceBlendshapes[0]?.categories[16].score) /
      2
    );
  }
  findSmile(data: any) {
    // (mouthSmileLeft + mouthSmileRight) / 2
    return (
      (data.faceBlendshapes[0]?.categories[44].score +
        data.faceBlendshapes[0]?.categories[45].score) /
      2
    );
  }
  findMouthOpen(data: any) {
    // jawOpen
    return data.faceBlendshapes[0]?.categories[25].score;
  }
  findGazeHorizontal(data: any) {
    const gazeRight =
      (data.faceBlendshapes[0]?.categories[13].score +
        data.faceBlendshapes[0]?.categories[16].score) /
      2;
    const gazeLeft =
      (data.faceBlendshapes[0]?.categories[14].score +
        data.faceBlendshapes[0]?.categories[15].score) /
      2;
    return (1 + gazeRight - gazeLeft) / 2;
  }
  findGazeVertical(data: any) {
    const gazeUp =
      (data.faceBlendshapes[0]?.categories[17].score +
        data.faceBlendshapes[0]?.categories[18].score) /
      2;
    const gazeDown =
      (data.faceBlendshapes[0]?.categories[11].score +
        data.faceBlendshapes[0]?.categories[12].score) /
      2;
    return (1 + gazeDown - gazeUp) / 2;
  }
  /////////////////////////////////////////
  // Gesture Finders - Head
  /////////////////////////////////////////
  // eslint-disable-next-line max-len
  // https://raw.githubusercontent.com/google/mediapipe/a908d668c730da128dfa8d9f6bd25d519d006692/mediapipe/modules/face_geometry/data/canonical_face_model_uv_visualization.png
  // findRollRight(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (
  //     (data.faceLandmarks[0][280].y - data.faceLandmarks[0][50].y) /
  //     Math.abs(data.faceLandmarks[0][280].x - data.faceLandmarks[0][50].x)
  //   );
  // }
  // findRollLeft(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (
  //     -(data.faceLandmarks[0][280].y - data.faceLandmarks[0][50].y) /
  //     Math.abs(data.faceLandmarks[0][280].x - data.faceLandmarks[0][50].x)
  //   );
  // }

  findYaw(data: any) {
    // Ponta do nariz em relação ao frame
    if (data.faceLandmarks.length > 0) {
      let point = data.faceLandmarks[0][4].x;
      const leftRef = data.faceLandmarks[0][50].x;
      const rightRef = data.faceLandmarks[0][280].x;
      // console.log(leftRef, point, rightRef);

      if (point < leftRef) {
        point = leftRef;
      } else if (point > rightRef) {
        point = rightRef;
      }
      let scaledValue = 1 - (point - leftRef) / (rightRef - leftRef);

      if (scaledValue < 0) {
        scaledValue = 0;
      } else if (scaledValue > 1) {
        scaledValue = 1;
      }

      return scaledValue;
    }
  }

  findYawLeft(data: any) {
    return 1 - this.findYaw(data);
  }

  findPitch(data: any) {
    if (data.faceLandmarks.length > 0) {
      const point = data.faceLandmarks[0][4].y; // Pega altura da ponta do nariz
      const centerRef =
        (data.faceLandmarks[0][234].y + data.faceLandmarks[0][454].y) / 2; // Em relação à media da altura das orelhas
      const a = data.faceLandmarks[0][50];
      const b = data.faceLandmarks[0][280];
      const scaleRef = Math.sqrt(
        Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2) + Math.pow(b.z - a.z, 2)
      );

      let scaledValue = ((point - centerRef) / scaleRef + 0.9) / 1.5;

      if (scaledValue < 0) {
        scaledValue = 0;
      } else if (scaledValue > 1) {
        scaledValue = 1;
      }

      return scaledValue;
    }
  }

  findPitchUp(data: any) {
    return 1 - this.findPitch(data);
  }

  findRoll(data: any) {
    if (data.faceLandmarks.length > 0) {
      const a = data.faceLandmarks[0][50];
      const b = data.faceLandmarks[0][280];
      const point = a.y - b.y; //Pega a diferença de altura entre os dois pontos da bochega
      const scaleRef = Math.sqrt(
        Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2) + Math.pow(b.z - a.z, 2)
      );

      let scaledValue = (point / scaleRef) * 0.7 + 0.5;

      if (scaledValue < 0) {
        scaledValue = 0;
      } else if (scaledValue > 1) {
        scaledValue = 1;
      }

      return scaledValue;
    }
  }

  findRollLeft(data: any) {
    return 1 - this.findRoll(data);
  }

  /**
   * @summary Checks if head is pointing away from camera in any direction
   * @param data Face blendshape task return
   * @returns measure of head pointing away from camera
   */

  findHeadPointingAway(data: any) {
    if (data.faceLandmarks.length > 0) {
      const pitchDeviation = Math.abs(this.findPitch(data) - 0.5);
      const yawDeviation = Math.abs(this.findYaw(data) - 0.5);
      return Math.max(pitchDeviation, yawDeviation);
    }
  }

  // TODO:
  // findPitchUp(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (data.faceBlendshapes[0]?.categories[13].score + data.faceBlendshapes[0]?.categories[16].score) / 2;
  // }
  // findPitchDown(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (data.faceBlendshapes[0]?.categories[13].score + data.faceBlendshapes[0]?.categories[16].score) / 2;
  // }
  // findYawLeft(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (data.faceBlendshapes[0]?.categories[13].score + data.faceBlendshapes[0]?.categories[16].score) / 2;
  // }
  // findYawRight(data: any) {
  //   // (eyeGazeInLeft + eyeGazeOutRight) / 2
  //   return (data.faceBlendshapes[0]?.categories[13].score + data.faceBlendshapes[0]?.categories[16].score) / 2;
  // }

  /////////////////////////////////////////
  // Gesture Finders - EyeTracker
  /////////////////////////////////////////
  findGazeH(data: PeyeCoordinates | RastreadorCoords) {
    return data.x;
  }
  findGazeV(data: PeyeCoordinates | RastreadorCoords) {
    return data.y;
  }

  /////////////////////////////////////////
  // Gesture Finders - Hands
  /////////////////////////////////////////
  findOpenPalm(data: any) {
    console.log(data);
    return data.gestures[0].categoryName === 'Open_Palm'
      ? data.gestures[0].score
      : 0;
  }
  findClosedFist(data: any) {
    return data.gestures[0].categoryName === 'Closed_Fist'
      ? data.gestures[0].score
      : 0;
  }
  findHandOne(data: any) {
    return data.gestures[0].categoryName === 'Pointing_Up'
      ? data.gestures[0].score
      : 0;
  }
  findHandTwo(data: any) {
    return data.gestures[0].categoryName === 'Victory'
      ? data.gestures[0].score
      : 0;
  }
  findThumbUp(data: any) {
    return data.gestures[0].categoryName === 'Thumb_Up'
      ? data.gestures[0].score
      : 0;
  }
  findThumbDown(data: any) {
    return data.gestures[0].categoryName === 'Thumb_Down'
      ? data.gestures[0].score
      : 0;
  }

  findHandH(data: any) {
    // const  x = 0.8-(data.landmarks[rightHandIndex][this.nodeTrackedForCursor].x - 0.5)*2;
    // const  y = data.landmarks[rightHandIndex][this.nodeTrackedForCursor].y*2-0.4;
    return data.gestures[0].categoryName === 'Thumb_Down'
      ? data.gestures[0].score
      : 0;
  }

  findHandV(data: any) {
    return data.gestures[0].categoryName === 'Thumb_Down'
      ? data.gestures[0].score
      : 0;
  }

  findDwellTime(data?: any) {
    //console.log('DwellTime', Date.now() - this.lastMovementTimestamp, this.lastMovementTimestamp);
    if (this.lastMovementTimestamp) {
      const interval = (Date.now() - this.lastMovementTimestamp) / 1000;
      return interval;
    }
    else { // undefined means timer disabled
      return 0;
    }
  }

  //////////////////////////////////////////
  // Mouse
  //////////////////////////////////////////
  findMouseClickLeft(data?: any) {
    // Check if left button is pressed
    return data.mouseLeftButton ? 1 : 0;
  }

  /////////////////////////////////////////
  // Actions - Scan
  /////////////////////////////////////////
  actionPause(index: number, detected: boolean, arg: any, dispatch: boolean = false, captureTime: number): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionPause');
      //this.binaryEventBS.next({ event: MappingsOutputType.pauseScan, captureTime }); // TODO: deprecate
      this.outputBS.next({ type: MappingsOutputType.pauseScan, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionSuspend(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionSuspend');
      //this.binaryEventBS.next({ event: MappingsOutputType.suspendScan, captureTime });
      this.outputBS.next({ type: MappingsOutputType.suspendScan, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionResume(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionResume');
      //this.binaryEventBS.next({ event: MappingsOutputType.resumeScan, captureTime });
      this.outputBS.next({ type: MappingsOutputType.resumeScan, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionSelect(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionSelect');
      //this.binaryEventBS.next({ event: MappingsOutputType.select, captureTime });
      this.outputBS.next({ type: MappingsOutputType.select, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    const state = this.state.mappings[index];
    const setting = this.settings.mappings[index];
    this.outputBS.next({ type: MappingsOutputType.feedbackSelect, value: (state.detectionLevel / setting.detectionThreshold), captureTime });
    return false; // Consider dispatch done
  }

  // OBS: 2. Cria a função de ação para o evento 
  actionVocalize(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionVocalize');
      this.outputBS.next({ type: MappingsOutputType.vocalize, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionCancel(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionCancel');
      //this.binaryEventBS.next({ event: MappingsOutputType.cancelSelection, captureTime });
      this.outputBS.next({ type: MappingsOutputType.cancelSelection, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionCancelAuto(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts]  actionCancelAuto');
      //this.binaryEventBS.next({ event: MappingsOutputType.cancelSelection, captureTime });
      this.outputBS.next({ type: MappingsOutputType.cancelSelectionAuto, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionUndo(index: number, detected: boolean, arg: any, dispatch: boolean = false, captureTime: number): boolean {
    if (dispatch && detected) {
      console.log('[shortcuts] actionUndo');
      //this.binaryEventBS.next({ event: MappingsOutputType.undo, captureTime });
      this.outputBS.next({ type: MappingsOutputType.undo, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionErase(index: number, detected: boolean, arg: any, dispatch: boolean = false, captureTime: number) {
    if (dispatch && detected) {
      console.log('[shortcuts] actionDelete');
      //this.binaryEventBS.next({ event: MappingsOutputType.erase, captureTime });
      this.outputBS.next({ type: MappingsOutputType.erase, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  actionRepeat(index: number, detected: boolean, arg: any, dispatch: boolean = false, captureTime: number) {
    if (dispatch && detected) {
      console.log('[shortcuts] actionRepeat');
      //this.binaryEventBS.next({ event: MappingsOutputType.repeat, captureTime });
      this.outputBS.next({ type: MappingsOutputType.repeat, captureTime });
      this.lastMovementTimestamp = undefined;
    }
    return false; // Consider dispatch done
  }

  /////////////////////////////////////////
  // Actions - Discrete
  /////////////////////////////////////////
  actionDiscreteWizardEvent(
    index: number,
    detected: boolean,
    arg: any,
    dispatch: boolean = false,
    captureTime: number
  ) {
    // Calibration wizard only
    if (dispatch) {
      console.log('[shortcuts] actionDiscreteWizardEvent', detected, arg);
      // this.binaryEventBS.next({
      //   event: MappingsOutputType.wizardEvent,
      //   data: arg,
      //   detected,
      //   captureTime
      // });
    }
    return false; // Consider dispatch done
  }

  /////////////////////////////////////////
  // Actions - Continuous
  /////////////////////////////////////////

  actionCursorH(index: number,
    captureTime: number) {

    const state = this.state.mappings[index];
    const setting = this.settings.mappings[index];

    // this.digitalEventBS.next({
    //   event: MappingsOutputType.feedbackPositionH,
    //   value: state.rescaledValue,
    //   resolution: setting.resolution,
    //   captureTime
    // });
    this.outputBS.next({
      type: MappingsOutputType.feedbackPositionH,
      value: state.rescaledValue,
      resolution: setting.resolution,
      captureTime
    });

    // Impede atualização do output discretizado se resolução for 0
    // Importante para não intervir no dwell time
    if (setting.resolution) {
      this.state.mappings[index].discretizedValue =
        this.discretizeInteger(
          this.state.mappings[index].rescaledValue,
          this.currentResH || setting.resolution || 6
        );
    }

    if (state.output !== state.discretizedValue) {
      this.lastMovementTimestamp = Date.now();
      state.output = state.discretizedValue;
      // this.digitalEventBS.next({
      //   event: MappingsOutputType.cursorPositionH,
      //   value: state.output,
      //   resolution: setting.resolution,
      //   captureTime
      // });
      this.outputBS.next({
        type: MappingsOutputType.cursorPositionH,
        value: state.output,
        resolution: setting.resolution,
        captureTime
      });
    }

    return false; // Consider dispatch done
  }

  actionCursorV(index: number,
    captureTime: number) {
    const state = this.state.mappings[index];
    const setting = this.settings.mappings[index];

    // this.digitalEventBS.next({
    //   event: MappingsOutputType.feedbackPositionV,
    //   value: state.rescaledValue,
    //   resolution: setting.resolution,
    //   captureTime
    // });
    this.outputBS.next({
      type: MappingsOutputType.feedbackPositionV,
      value: state.rescaledValue,
      resolution: setting.resolution,
      captureTime
    });

    // Impede atualização do output discretizado se resolução for 0
    // Importante para não intervir no dwell time
    if (setting.resolution) {
      this.state.mappings[index].discretizedValue =
        this.discretizeInteger(
          this.state.mappings[index].rescaledValue,
          this.currentResV || setting.resolution || 6
        );
    }


    if (state.output !== state.discretizedValue) {
      this.lastMovementTimestamp = Date.now();
      state.output = state.discretizedValue;
      // this.digitalEventBS.next({
      //   event: MappingsOutputType.cursorPositionV,
      //   value: state.output,
      //   resolution: setting.resolution,
      //   captureTime
      // });
      this.outputBS.next({
        type: MappingsOutputType.cursorPositionV,
        value: state.output,
        resolution: setting.resolution,
        captureTime
      });
    }

    return false; // Consider dispatch done
  }

  actionCursorHV(index: number,
    captureTime: number) {
    const state = this.state.mappings[index];
    const setting = this.settings.mappings[index];

    // this.digitalEventBS.next({
    //   event: MappingsOutputType.feedbackPositionHV,
    //   value: state.rescaledValue,
    //   resolution: setting.resolution,
    //   captureTime
    // });
    this.outputBS.next({
      type: MappingsOutputType.feedbackPositionHV,
      value: state.rescaledValue,
      resolution: setting.resolution,
      captureTime
    });

    // Impede atualização do output discretizado se resolução for 0
    // Importante para não intervir no dwell time
    if (setting.resolution) {
      this.state.mappings[index].discretizedValue =
        this.discretizeInteger(
          this.state.mappings[index].rescaledValue,
          this.currentResHV || setting.resolution || 6
        );
    }

    if (state.output !== state.discretizedValue) {
      this.lastMovementTimestamp = Date.now();
      state.output = state.discretizedValue;
      // this.digitalEventBS.next({
      //   event: MappingsOutputType.cursorPositionHV,
      //   value: state.output,
      //   resolution: setting.resolution,
      //   captureTime
      // });
      this.outputBS.next({
        type: MappingsOutputType.cursorPositionHV,
        value: state.output,
        resolution: setting.resolution,
        captureTime
      });
    }

    return false; // Consider dispatch done
  }

  actionCalibration(index: number,
    captureTime: number) {
    // const state = this.state.mappings[index];
    // const setting = this.settings.mappings[index];
    // console.log(scaledValue, discretizedValue, state.detectionLevel);

    return false; // Consider dispatch done
  }

  // /////////////////////////////////////////
  // // Actions - Mouse
  // /////////////////////////////////////////
  // actionLeftClick(detected: boolean, arg: any, dispatch: boolean = false): boolean {
  //   if (dispatch) {
  //     context.winRT.mouseClick(detected, false, false);
  //     if (context.state.dispatchMouse) {
  //       return context.winRT.mouseDispatch();
  //     }
  //   }
  //   return false; // Consider dispatch done
  // }
  // actionRightClick(detected: boolean, arg: any, dispatch: boolean = false): boolean {

  //   if (dispatch) {
  //     context.winRT.mouseClick(false, detected, false);
  //     //console.log('Left Click', detected);
  //     if (context.state.dispatchMouse) {
  //       return context.winRT.mouseDispatch();
  //     }
  //   }
  //   return false; // Consider dispatch done
  // }
  // /////////////////////////////////////////
  // // Actions - Keyboard
  // /////////////////////////////////////////
  // actionKeyboard(detected: boolean, arg: string, dispatch: boolean = false) {
  //   //console.log('actionKeyboard');
  //   if (detected && dispatch) {
  //     return context.winRT.keyboardStroke(arg);
  //   }
  //   return false;
  // }
  /////////////////////////////////////////
  // Actions - Internal Commands
  /////////////////////////////////////////
  actionEnableControl(
    index: number,
    detected: boolean,
    arg: string,
    dispatch: boolean = false,
    captureTime: number
  ) {
    //console.log('actionKeyboard');
    if (detected && dispatch) {
      console
      this.globalCommandsBS.next('enableControl');
      this.lastMovementTimestamp = undefined;
    }
    return false;
  }
  actionDisableControl(
    index: number,
    detected: boolean,
    arg: string,
    dispatch: boolean = false,
    captureTime: number
  ) {
    //console.log('actionKeyboard');
    if (detected && dispatch) {
      console.log('actionDisableControl');
      this.globalCommandsBS.next('disableControl');
      this.lastMovementTimestamp = undefined;
    }
    return false;
  }

  /////////////////////////////////////////
  // Actions - IoT
  /////////////////////////////////////////

  /////////////////////////////////////////
  // Actions - System Commands
  /////////////////////////////////////////

  disableMovementCapture(index: number, detected: boolean, arg: any, dispatch: boolean, captureTime: number) {
    if (detected && dispatch) {
      this.state.muted = true;
      this.vision.mappingsPaused = this.state.muted;
      console.log('disableMovementCapture', this.state.muted);
      this.lastMovementTimestamp = undefined;
    }
    return false;
  }

  enableMovementCapture(index: number, detected: boolean, arg: any, dispatch: boolean, captureTime: number) {
    if (detected && dispatch) {
      this.state.muted = false;
      this.vision.mappingsPaused = this.state.muted;
      console.log('enableMovementCapture', this.state.muted);
      this.lastMovementTimestamp = undefined;
    }
    return false;
  }

  toggleMovementCapture(index: number, detected: boolean, arg: any, dispatch: boolean, captureTime: number) {
    if (detected && dispatch) {
      this.state.muted = !this.state.muted;
      this.vision.mappingsPaused = this.state.muted;
      console.log('toggleMovementCapture', this.state.muted);
      this.lastMovementTimestamp = undefined;
    }
    return false;
  }
  /////////////////////////////////////////
  // Actions - Other
  /////////////////////////////////////////


  // playAudio(name: string) {
  //   const isPlaying =
  //     this.audio.currentTime > 0 &&
  //     !this.audio.paused &&
  //     !this.audio.ended &&
  //     this.audio.readyState > this.audio.HAVE_CURRENT_DATA;

  //   if (isPlaying) {
  //     this.audio.pause();
  //     this.audio.currentTime = 0;
  //     //Avoid the Promise Error
  //     setTimeout(() => {
  //       console.log('playAudio', name);
  //       this.audio.src = 'assets/sounds/' + name + '.mp3';
  //       this.audio.load();
  //       this.audio
  //         .play()
  //         .then(() => {
  //           //this.audio.pause();
  //         })
  //         .catch(() => {
  //           this.audio.pause();
  //           this.audio.currentTime = 0;
  //         });
  //     }, 150);
  //   } else {
  //     console.log('playAudio', name);
  //     this.audio.src = 'assets/sounds/' + name + '.mp3';
  //     this.audio.load();
  //     this.audio
  //       .play()
  //       .then(() => {
  //         //this.audio.pause();
  //       })
  //       .catch(() => {
  //         this.audio.pause();
  //         this.audio.currentTime = 0;
  //       });
  //   }
  // }

  functionFromId(
    id: string
  ):
    | ((data: any) => number)
    | ((detected: boolean, arg: any, dispatch: boolean, captureTime: number) => boolean)
    | ((index: number) => boolean) {

    if (this.hasOwnProperty(id) && typeof this[id] === 'function') {
      console.log('Mapping function ID not found', id);
      return undefined;
    }
    return this[id];
  }

  registerMapping(mapping: MappingsItemSettings) {
    this.state.mappings.push({
      detected: false,
      suspected: false,
      detectionLevel: 0,
      rescaledValue: 0,
      discretizedValue: 0,
      lastHysteresisRef: 0,
      lastDelta: 0,
      output: 0,
      dispatchPending: false,
      startTimestamp: 0,
    });
    this.settings.mappings.push(mapping);
  }

  setProfile(profile: Profile) {
    console.groupCollapsed('[mappings] setProfile', profile);
    this.settings.enabled = false;
    this.settings.mappings = [];
    this.state.mappings = [];
    // console.log('mappings 0 ',this.settings.mappings);

    // Get Directions
    profile.navSettingsBundle.directions.forEach((dir) => {
      dir.mappings.forEach((mapping) => {
        this.registerMapping(mapping);
      });
    });
    // console.log('mappings 1 ',this.settings.mappings);

    // Get Switches
    profile.navSettingsBundle.switches.forEach((sw) => {
      sw.mappings.forEach((mapping) => {
        this.registerMapping(mapping);
      });
    });

    // console.log('mappings 2 ',this.settings.mappings);
    console.groupEnd();
    this.settings.enabled = true;

    let inflatedMapppings: MappingsItemSettings[] = [];
    this.settings.mappings.forEach((mapping) => {
      const defaultMapping = {
        name: null,
        enabled: false,
        priority: null,
        resolution: null,
        movement: {
          name: null,
          function: null,
          source: null,
          filterClass: null,
          driver: [null],
        },
        detectionThreshold: null,
        detectionAction: {
          name: null,
          function: null,
          filterClass: null,
        },
        hysteresis: null,
      };
      inflatedMapppings.push(Object.assign(defaultMapping, mapping));
    });

    // Bugfix: Resolve problema de crash ao abrir o app quando o perfil declara driver sem ser um array
    // convert all driver keys from Driver | Array<Driver> to Array<Driver>
    let androidMappings: MappingsItemSettings[] = [];
    inflatedMapppings.forEach((mapping) => {
      if (mapping.movement.driver) {
        if (!Array.isArray(mapping.movement.driver)) {
          mapping.movement.driver = [mapping.movement.driver];
        }
      }
      androidMappings.push(mapping);
    });

    //console.log('config to android: ', this.settings.mappings, androidMappings);
    this.androidControl.receiveConfig(androidMappings);
    //transform this.profile.navSettingsBundle.bundleOptionsState.scanInterval in string
    this.androidControl.getScanInterval(this.profile.navSettingsBundle.bundleOptionsState.scanInterval);
    //this.androidControl.getTouchDuration(this.profile.navSettingsBundle.bundleOptionsState.touchFilterDuration);

    // Avoid leaving the movement capture disabled when removing a switch
    this.state.muted = false;
    this.vision.mappingsPaused = this.state.muted;

  }
}
